import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api.service';
import './LatestBlogs.css';

const LatestBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const response = await apiService.getCmsBlogs({ page: 1, pageSize: 3 });
      setBlogs(response.data.items || []);
    } catch (error) {
      console.error('Error fetching blogs:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getExcerpt = (content, length = 100) => {
    if (!content) return '';
    const text = content.replace(/<[^>]*>/g, ''); // Remove HTML tags
    return text.length > length ? text.substring(0, length) + '...' : text;
  };

  if (loading) {
    return (
      <div className="blog-section blog-loading">
        <div className="container">
          <div className="text-center">Loading blog posts...</div>
        </div>
      </div>
    );
  }

  if (blogs.length === 0) {
    return null;
  }

  return (
    <div className="blog-section">
      <div className="container">
        <div className="section-header text-center">
          <p>Latest Updates</p>
          <h2>Blog & News</h2>
        </div>
        <div className="row">
          {blogs.map((blog) => (
            <div key={blog.slug} className="col-lg-4 col-md-6">
              <div className="blog-card">
                <div className={`blog-image ${!blog.featuredImageUrl ? 'blog-image-placeholder' : ''}`}>
                  {blog.featuredImageUrl ? (
                    <img
                      src={blog.featuredImageUrl}
                      alt={blog.title}
                      onError={(event) => {
                        event.currentTarget.style.display = 'none';
                        event.currentTarget.parentElement.classList.add('blog-image-placeholder');
                      }}
                    />
                  ) : (
                    <div className="blog-placeholder-content">
                      <i className="far fa-newspaper"></i>
                    </div>
                  )}
                  <Link to={`/blog/${blog.slug}`} className="blog-overlay-link">
                    <span className="read-more">Read More</span>
                  </Link>
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-date">
                      <i className="far fa-calendar"></i> {formatDate(blog.publishedUtc)}
                    </span>
                    <span className="blog-author">
                      <i className="far fa-user"></i> {blog.authorDisplayName || 'Admin'}
                    </span>
                  </div>
                  <h4 className="blog-title">
                    <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
                  </h4>
                  {blog.categoryName && <span className="blog-category">{blog.categoryName}</span>}
                  <p className="blog-excerpt">{getExcerpt(blog.excerpt, 100)}</p>
                  <Link to={`/blog/${blog.slug}`} className="blog-link">
                    Read Article
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop: '30px' }}>
          <Link to="/blog" className="btn btn-primary">
            View All Blog Posts
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LatestBlogs;
